module.exports = __webpack_public_path__ + "img/mp4.dc0efed9.svg";